import React, { type FC } from "react";
import { shallowEqual } from "react-redux";
import clsx from "clsx";
import { formatPriceIntl } from "../../../../../../../common-deprecated/priceUtils";
import { useCarConfigSelector } from "../../../../redux/store";
import Text from "../../../../../shared-components/css-modules/lexus/atoms/Text";
import styles from "../header/Cta.module.scss";
import { CarConfigLabel } from "../../../../utils/labelUtils";
import { useCommonSelector } from "../../../../../../../common-deprecated/redux/commonStore";
import { dualCurrencyDisclaimerSelector } from "../../../../../../../shared-logic/utils/dualCurrencyDisclaimerUtils";
import Popover from "../../../../../shared-components/css-modules/lexus/vendor/popover/Popover";
import Button from "../../../../../shared-components/css-modules/lexus/atoms/Button";
import Icon from "../../../../../shared-components/css-modules/lexus/atoms/Icon";
import { limitFractionDigits } from "../../../../../../../shared-logic/utils/priceUtils";

const ExchangeRate: FC<{ monthly?: boolean }> = ({ monthly }): JSX.Element => {
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const dualCurrencyDisclaimer = useCommonSelector(dualCurrencyDisclaimerSelector, shallowEqual);

    const { primaryPrice, secondaryPrice } = formatPriceIntl(
        commonSettings,
        1,
        { currencyDisplay: "code" },
        true,
        undefined,
        // as secondary value is not really a price that needs to take in
        // account maximumFractionDigits from commonSettings, we set it to max
        20,
        commonSettings.reverseCurrencyMultiplier,
    );

    return (
        <div>
            <Text
                tag="div"
                variant="apheleia-body-large"
                className={clsx(!monthly ? styles["finance-representative-disclaimer"] : "")}
            >
                <div className={styles["exchange-rate"]}>
                    <CarConfigLabel
                        label="carConfigExchangeRate"
                        params={{
                            primaryPrice: limitFractionDigits(primaryPrice, 2),
                            secondaryPrice: limitFractionDigits(secondaryPrice || "0", 2),
                        }}
                    />
                    {dualCurrencyDisclaimer && (
                        <Popover>
                            <Popover.Trigger>
                                <Button variant="clean" type="button">
                                    <Icon variant="info" sizing="md" aria-hidden="true" />
                                </Button>
                            </Popover.Trigger>
                            <Popover.Content>{dualCurrencyDisclaimer}</Popover.Content>
                        </Popover>
                    )}
                </div>
            </Text>
        </div>
    );
};

export default ExchangeRate;
